import React, { forwardRef } from 'react';

export const Checkbox = forwardRef(function Checkbox(
  { className = '', ...props },
  ref
) {
  return (
    <input
      ref={ref}
      type="checkbox"
      className={`h-4 w-4 rounded border-zinc-300 text-brand-red-500 focus:ring-brand-red-500 dark:border-zinc-600 dark:bg-zinc-800 dark:focus:ring-brand-red-400 ${className}`}
      {...props}
    />
  );
});

export function CheckboxField({ className = '', children, ...props }) {
  return (
    <div className={`flex gap-2 ${className}`} {...props}>
      {children}
    </div>
  );
}

export default { Checkbox, CheckboxField }; 